import {Component, inject, Input} from '@angular/core';

import {RecordDataValue, SelectData} from "../../../../../types/records-table.types";
import {DynamicService} from "../services/dynamic.service";
import {SnackbarService} from "../../../../../services/snackbar.service";
import {DynamicSelectStateService} from "../services/dynamic-select-state.service";
import {GetSelectDataParams} from "../types/dynamic.types";
import {MultiSelectTableItemComponent} from "../multi-select-table-item/multi-select-table-item.component";

@Component({
  selector: 'app-dynamic-multi-select-table-item',
  standalone: false,
  templateUrl: './dynamic-multi-select-table-item.component.html',
  styleUrls: [
    '../../base-record-table-item-styles.scss',
    '../single-select-table-item/single-select-table-item.component.scss',
    './dynamic-multi-select-table-item.component.scss'
  ]
})
export class DynamicMultiSelectTableItemComponent extends MultiSelectTableItemComponent {
  @Input({ required: true }) dynamicValue?: RecordDataValue;

  private dynamicService: DynamicService = inject(DynamicService);
  private snackbarService: SnackbarService = inject(SnackbarService);
  private dynamicSelectStateService: DynamicSelectStateService = inject(DynamicSelectStateService);

  private isProduct: boolean = false;

  public override async ngOnInit() {
    super.ngOnInit();
    this.isProduct = this.columnParam.key === 'productId';
    this.selectData = this.dynamicSelectStateService.dynamicState()[this.columnParam.key];
  }

  public override async handleSelectClick(): Promise<void> {
    this.selectData = await this.getOptions();
    if (!this.selectData?.length) {
      this.snackbarService.showMessage({
        type: 'info',
        message: 'Нет данных'
      });
    }

    this.changeDetectorRef.detectChanges();
    this.matSelect.open();
  }

  private async getOptions(): Promise<Array<SelectData>> {
    const getSelectDataParams: GetSelectDataParams = {
      ...this.dynamicService.getDefaultSelectDataParams(this.isProduct),
      productIds: !this.isProduct ? (this.dynamicValue as Array<string>)?.length ? this.dynamicValue as Array<string> : null : null,
      articles: this.isProduct ? (this.dynamicValue as Array<string>)?.length ? this.dynamicValue as Array<string> : null : null
    };

    return await this.dynamicService.getSelectData(getSelectDataParams);
  }
}
